/* import __COLOCATED_TEMPLATE__ from './conversation-unmarked-as-spam.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type ConversationUnmarkedAsSpam from 'embercom/objects/inbox/renderable/conversation-unmarked-as-spam';

interface ConversationUnmarkedAsSpamPart extends RenderablePart {
  renderableData: ConversationUnmarkedAsSpam;
}

interface Args {
  part: ConversationUnmarkedAsSpamPart;
}

interface Signature {
  Args: Args;
}

export default class ConversationUnmarkedAsSpamComponent extends Component<Signature> {
  @service declare session: Session;

  get renderableData() {
    return this.args.part.renderableData;
  }

  get adminSummary() {
    return this.renderableData.adminSummary;
  }

  get isCurrentUser() {
    return this.adminSummary.id === this.session.teammate?.id;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ConversationUnmarkedAsSpam': typeof ConversationUnmarkedAsSpamComponent;
    'inbox2/conversation-stream/event-parts/conversation-unmarked-as-spam': typeof ConversationUnmarkedAsSpamComponent;
  }
}
